import React from 'react';

/**
 * Small status for designer cards. acceptingNewProjects defaults true when unknown.
 */
export default function DesignerAvailabilityBadge({ acceptingNewProjects = true, className = '' }) {
  const on = acceptingNewProjects !== false;
  return (
    <div className={`flex items-center gap-1.5 text-xs ${className}`} aria-live="polite">
      <span
        className="rounded-full flex-shrink-0"
        style={{
          width: 6,
          height: 6,
          backgroundColor: on ? '#16a34a' : '#9ca3af',
        }}
        aria-hidden
      />
      <span className={on ? 'text-green-800' : 'text-gray-500'}>
        {on ? 'Accepting projects' : 'Currently unavailable'}
      </span>
    </div>
  );
}
